// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__BEmnW","pulse":"skeleton_pulse__UTTPg"};